'use strict';

function addSelectionEventHandler(element, func) {
  element.addEventListener('click', func);
  element.addEventListener('keyup', function (event) {
    if (event.keyCode === 13) {
      func();
    }
  });
}

module.exports = addSelectionEventHandler;



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/lib/add-selection-event-handler.js
// module id = 214
// module chunks = 0